import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import LazyLoad from "react-lazyload";
import { IoIosArrowDown } from "react-icons/io";
import { fetchHomeVideo } from "../../api";
import saroojicon from "../../images/map/sarooj-icon.png";

function Video({ scrollToCommunity }) {
  const [socialmedia, setSocialMedia] = useState({});

  useEffect(() => {
    fetchHomeVideo(setSocialMedia);
  }, []);
  return (
    <div className="relative w-[100%] h-[100%] font-[cairo]">
      {socialmedia?.homeVideo && (
        <LazyLoad height={200} offset={100} once>
          <video
            className="relative w-full h-[95vh] lg:h-[80vh] md:h-[60vh] lg:mt-[5%] object-cover z-0"
            autoPlay
            muted
            loop
          >
            <source
              src={`https://saroojdevelopment.com/laravel/public/api/storage/${socialmedia.homeVideo}`}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </LazyLoad>
      )}

      <div className="absolute inset-0 bg-[#00000057] z-10"></div>

      <div className="w-[100%] text-[80px] absolute top-[85%] font-[100] text-white flex justify-center items-center z-20">
        <IoIosArrowDown
          onClick={scrollToCommunity}
          className="cursor-pointer bounce"
        />
      </div>
    </div>
  );
}

export default Video;
